import {SingleMetric} from "@/pages/pagespeed/report/body/performance/SingleMetric.tsx";
import {LHRAudit, PSReportCategories} from "@/pages/pagespeed/types.ts";

interface PerformanceMetricsProps {
  categories: PSReportCategories;
  audits: Record<string, LHRAudit>;
}

export const PerformanceMetrics = ({categories, audits}: PerformanceMetricsProps) => {
  const metrics = categories?.performance.auditRefs
    ?.filter((i) => i.group === "metrics")
    .sort((a, b) => (a.weight > b.weight ? -1 : b.weight > a.weight ? 1 : 0));
  return (
    <div className="d-flex audit-metrics-container">
      {metrics?.map((m) => (
        <SingleMetric key={`metric-${m.id}`} audit={audits[m.id]} />
      ))}
    </div>
  );
};
